import { useState, useEffect } from 'react';
import { Card } from '../components/UI';
import { personelAPI } from '../utils/api';

const stat = (label, value, color, sub) => (
  <div style={{ background:`${color}10`, borderRadius:12, padding:20, minWidth:0 }}>
    <div style={{ fontSize:32, fontWeight:800, color }}>{value}</div>
    <div style={{ fontSize:13, color:'#6B7280', marginTop:2 }}>{label}</div>
    {sub && <div style={{ fontSize:11, color:'#9CA3AF', marginTop:4 }}>{sub}</div>}
  </div>
);

const badge = (text, color) => (
  <span style={{ padding:'2px 8px', borderRadius:6, fontSize:10, fontWeight:700, color:'#fff', background:color }}>{text}</span>
);

const MODULE_COLORS = { binkar:'#3B82F6', tahor:'#8B5CF6', pensiun:'#EF4444', personel:'#10B981', bagtapyan:'#F59E0B' };
const AKSI_COLORS = { APPROVE:'#059669', REJECT:'#EF4444', SUBMIT:'#3B82F6', POSTING:'#8B5CF6' };

export default function HrDashboardPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    personelAPI.getHrDashboard()
      .then(r => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading dashboard...</p>;
  if (!data) return <p style={{ color:'#9CA3AF' }}>Gagal memuat dashboard</p>;

  const { personel, kenaikan_pangkat: kp, pemindahan, pensiun, tahor, recent_approvals } = data;

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:22, fontWeight:700, color:'#111827', margin:0 }}>HR Dashboard</h1>
        <p style={{ color:'#6B7280', fontSize:13, margin:'4px 0 0' }}>Ringkasan data personel dan aktivitas HR</p>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:16, marginBottom:20 }}>
        {stat('Personel Aktif', Number(personel.aktif || 0).toLocaleString(), '#2563EB', `Total: ${Number(personel.total || 0).toLocaleString()}`)}
        {stat('Pensiun', Number(personel.pensiun || 0).toLocaleString(), '#F59E0B')}
        {stat('Meninggal', Number(personel.meninggal || 0).toLocaleString(), '#6B7280')}
        {stat('Pending Approval', (Number(kp.pending || 0) + Number(pemindahan.pending || 0) + Number(pensiun.pending || 0) + Number(tahor.draft || 0)).toLocaleString(), '#EF4444')}
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:20 }}>
        <Card>
          <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:700 }}>Kenaikan Pangkat (Binkar)</h3>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#F59E0B' }}>{kp.pending || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Proses</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#059669' }}>{kp.selesai || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Selesai</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#374151' }}>{kp.total || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Total</div>
            </div>
          </div>
        </Card>

        <Card>
          <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:700 }}>Pemindahan (Mutasi)</h3>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#F59E0B' }}>{pemindahan.pending || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Proses</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#059669' }}>{pemindahan.selesai || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Selesai</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#374151' }}>{pemindahan.total || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Total</div>
            </div>
          </div>
        </Card>

        <Card>
          <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:700 }}>Pensiun</h3>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#F59E0B' }}>{pensiun.pending || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Proses</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#059669' }}>{pensiun.final || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Final</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#374151' }}>{pensiun.total || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Total</div>
            </div>
          </div>
        </Card>

        <Card>
          <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:700 }}>Tahor (Tanda Kehormatan)</h3>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#F59E0B' }}>{tahor.draft || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Draft</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#059669' }}>{tahor.terposting || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Terposting</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:24, fontWeight:800, color:'#374151' }}>{tahor.total || 0}</div>
              <div style={{ fontSize:11, color:'#6B7280' }}>Total</div>
            </div>
          </div>
        </Card>
      </div>

      <Card>
        <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:700 }}>Aktivitas Approval Terbaru</h3>
        {recent_approvals.length === 0
          ? <p style={{ color:'#9CA3AF', textAlign:'center' }}>Belum ada aktivitas approval</p>
          : (
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr style={{ background:'#F8FAFC' }}>
                {['Waktu','Modul','Aksi','Pelaku','Status'].map(h =>
                  <th key={h} style={{ padding:'10px 14px', textAlign:'left', fontSize:12, fontWeight:700, color:'#64748B', borderBottom:'2px solid #E2E8F0' }}>{h}</th>
                )}
              </tr></thead>
              <tbody>
                {recent_approvals.map((r, i) => (
                  <tr key={i} style={{ background: i%2===0?'transparent':'#FAFAFA' }}>
                    <td style={{ padding:'10px 14px', fontSize:12, borderBottom:'1px solid #F1F5F9', color:'#6B7280' }}>
                      {new Date(r.dilakukan_at).toLocaleString('id-ID', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' })}
                    </td>
                    <td style={{ padding:'10px 14px', fontSize:12, borderBottom:'1px solid #F1F5F9' }}>
                      {badge(r.module, MODULE_COLORS[r.module] || '#6B7280')}
                    </td>
                    <td style={{ padding:'10px 14px', fontSize:12, borderBottom:'1px solid #F1F5F9' }}>
                      {badge(r.aksi, AKSI_COLORS[r.aksi] || '#6B7280')}
                    </td>
                    <td style={{ padding:'10px 14px', fontSize:13, borderBottom:'1px solid #F1F5F9', color:'#374151' }}>{r.pelaku || '-'}</td>
                    <td style={{ padding:'10px 14px', fontSize:12, borderBottom:'1px solid #F1F5F9', color:'#6B7280' }}>
                      {r.status_dari && r.status_ke ? `${r.status_dari} → ${r.status_ke}` : r.status_ke || '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
      </Card>
    </div>
  );
}
